import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconUserSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="24" height="24" viewBox="0 0 24 24"
             className={classNames(['svg-icon svg-cards', className])}>
            <path className="a" d="M0,0H24V24H0Z" fill="none"/>
            <path className="b" fill={color}
                  d="M12,12A4,4,0,1,0,8,8,4,4,0,0,0,12,12Zm0,2c-2.67,0-8,1.34-8,4v1a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V18C20,15.34,14.67,14,12,14Z"/>
        </svg>

    );
};

IconUserSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconUserSVG.defaultProps = {
    color: '#32cccc',
    className: '',
};

export default IconUserSVG;